import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { StorageProducts } from "../cart-apis/interfaces/cart.interface";
import { EstablishmentInfo } from "./interfaces/purchase.interface";
import { EstablishmentInfoService } from "../info-establishment/establishment-info.service";
import { UserGetAddressCleanService } from "../user-get-address-clean/user-get-address-clean.service";
import { HttpClient } from "@angular/common/http";
import { PrePurchaseService } from "../pre-purchase/pre-purchase.service";
import { AuthService } from "../auth.service";
import { IsDeliveryFreeService } from "../is-delivery-free/is-delivery-free.service";

@Injectable({
  providedIn: 'root'
})

export class SyncPricesCartService {
  private apiUrl = environment.apiUrl;
  private productsCart: StorageProducts[] = [];
  private infoEstablishment: EstablishmentInfo = {
    id_products: [],
    id_establishment: 0
  };
  constructor(
    private establishmentInfoService: EstablishmentInfoService,
    private userGetAddressCleanService: UserGetAddressCleanService,
    private http: HttpClient,
    private prePurchaseService: PrePurchaseService,
    private authService: AuthService,
    private isDeliveryFreeService: IsDeliveryFreeService



  ) {

  }

  // setProductsCart(products: StorageProducts[]): void {
  //   this.productsCart = products;
  //   console.log('prudctos', this.productsCart);

  // }

  // getProductsCart(): StorageProducts[] {
  //   return this.productsCart;
  // }



  // private async prepareCartData(items: StorageProducts[] = this.productsCart) {
  //   const addressUser = await firstValueFrom(this.userGetAddressCleanService.getCurrentAddress());
  //   const establishment_id = this.productsCart[0].items[0].pg_establishments_id;

  //   this.establishmentInfoService.setInfoEstablishment({
  //     id_products: this.productsCart.map((item: StorageProducts) =>
  //       item.items.map(product => Number(product.pd_id))).flat(),
  //     id_establishment: Number(establishment_id)
  //   });

  //   // Obtener los datos de envío
  //   const deliveryData = await firstValueFrom(this.prePurchaseService.getCoordinates());

  //   // Create properly formatted items array for the order
  //   const formattedItems = items.flatMap((storageProduct: StorageProducts) =>
  //     storageProduct.items.map(product => ({
  //       product_id: product.pd_id,
  //       quantity: product.quantity,
  //       unit_price: product.pd_unit_price,
  //       subtotal: product.subtotal,
  //     }))
  //   );

  //   const orderData = {
  //     order: {
  //       establishment_id: establishment_id,
  //       items: formattedItems,
  //       delivery: {
  //         shipping_cost: deliveryData.shipping_cost,
  //         km: deliveryData.km,
  //         address: {
  //           full_address: addressUser.ad_full_address,
  //           latitude: addressUser.ad_latitude.toString(),
  //           longitude: addressUser.ad_longitude.toString(),
  //           ad_id: addressUser.ad_id
  //         },
  //       },
  //       summary: {
  //         total: items[0].total,
  //         currency: "MXN"
  //       }
  //     }
  //   };

  //   console.log(orderData);
  //   return orderData;
  // }
  // // private calculateTotal(items: StorageProducts[]): number {
  // //   return items.reduce((sum, item) => sum + (item. || 0), 0);
  // // }
  getInfoEstablishment(): EstablishmentInfo {
    return this.infoEstablishment;
  }

  // purchaseCart(): Observable<PurchaseResponse> {
  //   return from(this.prepareCartData()).pipe(
  //     switchMap((cartData) => {
  //       const user = this.authService.getToken();
  //       const headers = new HttpHeaders({
  //         'Authorization': `Bearer ${user}`
  //       });
  //       console.log('Sending purchase request with data:', cartData);
  //       return this.http.post<PurchaseResponse>(
  //         `${this.apiUrl}/purchase`,
  //         cartData,
  //         { headers }
  //       );
  //     }),
  //     tap(response => {
  //       //pasar a mercado pago el costo del pedido total.
  //       this.isDeliveryFreeService.setShippingCost(response.data.shipping_cost);
  //       // this.isDeliveryFreeService.setTotalCost(response.data.total_cost);
  //       console.log('Purchase response:', response);
  //     }),
  //     catchError(error => {
  //       //manejar el error
  //       return throwError(() => error);
  //     }),
  //     shareReplay(1)
  //   );
  // }

}
